import styled from "styled-components";

import { IconButton } from "@similarweb/ui-components";

const ButtonContainer = styled.div`
    margin-left: auto;

    div {
        margin-right: 8px;
    }
`;

ButtonContainer.displayName = "ButtonContainer";

export const StyledIconButton = styled(IconButton)`
    svg path {
        fill-opacity: 1;
    }
`;
